/* ---- Bottom tab bar component ---- */

import { tabIcon } from '../icons';
import type { TabId } from '../types';

interface TabDef {
  id: TabId;
  label: string;
}

const TABS: TabDef[] = [
  { id: 'map', label: '現在地' },
  { id: 'history', label: '履歴' },
  { id: 'settings', label: 'ユーザ' },
];

export function renderTabBar(activeTab: TabId, onSwitch: (tab: TabId) => void): HTMLElement {
  const el = document.createElement('div');
  el.className = 'tb';

  TABS.forEach((tab) => {
    const isActive = activeTab === tab.id;
    const btn = document.createElement('button');
    btn.className = 'ti' + (isActive ? ' a' : '');
    btn.innerHTML = `${tabIcon(tab.id, isActive)}<span class="tl">${tab.label}</span>`;
    btn.addEventListener('click', () => onSwitch(tab.id));
    el.appendChild(btn);
  });

  return el;
}
